import React from 'react';
import { PersonaRegistModal } from './PersonaRegistModal';
import { GetUserResut } from 'config/api';
import { useModal } from 'hooks/useModal';
import { useRouting } from 'hooks/useRouting';

export const PersonaRegistInfo = ({ userInfo }: { userInfo: GetUserResut }) => {
  const routing = useRouting();
  const [isShowRegistModal] = useModal(true);

  return (
    <PersonaRegistModal
      hide={() => routing.pushRouting({ path: '/home' }, true)}
      isShow={isShowRegistModal}
      registBirthday={userInfo.Birthday}
      registAnnualIncome={userInfo.AnnualIncome}
      registInvestmentStartDate={userInfo.InvestmentStartDate}
      buttonText="登録"
      isFirst={true}
      close={() => document.location.reload()}
    />
  );
};
